import { RLogin } from './RLogin'
import './i18n'
export * from './constants'
export * from './constants/events'
export * from './components/shared/RLoginButton'

export default RLogin
